const additionalInformation = {
	additionalInformationsSubheader: 'Doplňující informace k PS',
	additionalInformationsProductSystem: 'Produktový systém',
	additionalInformationsOwnerA: 'Získatel A',
	additionalInformationsOwner: 'Získatel',
	additionalInformationsVinkulace: 'Vinkulace',
	additionalInformationsOwnerB: 'Získatel B',
	additionalInformationsFrequencyPayment: 'Frekvence placení',
	additionalInformationsDealAgency: 'Agentura sjednání',
	additionalInformationsMessageAgency: 'Agentura správy',
	additionalInformationsPaidUntil: 'Zaplaceno do',
	additionalInformationsBankCode: 'Kód banky',
	additionalInformationsTypeOfRate: 'Typ sazby',
	additionalInformationsRateGrid: 'Sazba',
	additionalInformationsNameOperator: 'Jméno operátora',
	additionalInformationsPhoneOperator: 'Telefon na operátora',
	additionalInformationsCodeOfProduct: 'Kód produktu',
	additionalInformationsOperatorNo: 'Číslo operátora',
	additionalInformationsSaleryGrid: 'Výše částky k výplatě',
	additionalInformationsAgencyAdmGrid: 'Agentura správy',
	additionalInformationsSalery: 'Výše částky k výplatě',
	additionalInformationsValorization: 'Valorizace',
	additionalInformationsInsurace: 'Pojistná částka život',
	additionalInformationsInsuraceTax: 'Daň',
	additionalInformationsPaidInsurance: 'Předpisové BP',
	additionalInformationsOverwriteInsurance: 'Předpisové JP',
	additionalInformationsSurvivalDateMethod: 'Typ kvitance',
	additionalInformationsSurvivalDateText: 'Datum dožití',
	additionalInformationsLoyaltyPremium: 'Věrnostní prémie',
	additionalInformationsLoyaltyBonus: 'Věrnostní bonus',
	additionalInformationsTarif: 'Tarif',
	additionalInformationsPremium: 'Zvláštní prémie',
	additionalInformationsRate: 'Sazba',
	additionalInformationsTotal: 'Celkem',
};

const asideBar = {
	asideBarMainHeader: 'Informace o PS',
	asideBarMainPSNumber: 'Číslo PS',
	asideBarMainProposalNumber: 'Číslo návrhu GP',
	asideBarMainInsurance: 'Pojištění',
	asideBarMainPSStatus: 'Stav PS',
	asideBarMainDateNegotiation: 'Datum sjednání PS',
	asideBarMainDateBegining: 'Datum počátku PS',
	asideBarMainDateEnd: 'Datum ukončení PS',
	asideBarMainSecondHeader: 'Informace o klientovi',
	asideBarBirthNumber: 'Rodné číslo',
	asideBarBusinessIn: 'IČO',
	asideBarName: 'Příjmení a jméno',
	asideBarStreet: 'Ulice',
	asideBarCity: 'Obec',
	asideBarPSC: 'PSČ',
	asideBarPhone: 'Telefon',
	asideBarEmail: 'E-mail',
	asideBarContactEmail: 'Kontaktní e-mail',
	asideBarContactPhone: 'Kontaktní telefon',
	asideBarClaimNo: 'Číslo PU',
};

const asideBarButtons = {
	asideBarButtonHistory: 'Historie úkolu',
	asideBarButtonGet: 'Předat',
	asideBarButtonTake: 'Převzít',
	asideBarButtonPrint: 'Tisk',
	asideBarButtonPrintNEIN: 'Tisk NEIN',
	asideBarButtonProcessInfo: 'Zpracovat informaci',
	asideBarButtonOpenPszpNoticeModal: 'Avízo dožití',
	asideBarButtonPszpNotice: 'Avízo dožití oprávněné osoby',
	asideBarButtonGOLP: 'Dodatek OLP',
	asideBarButtonEmail: 'Odeslat kopii úkolu emailem',
	asideBarButtonGreq133: 'Žádanka',
	asideBarButtonProspector: 'Prospector',
};

const attachments = {
	attachmentsSubheader: 'Přehled příloh',
};

const feedBack = {
	feedBackSubheader: 'Zpětná vazba',
	feedBackContractContinue: 'Vyřizeno - smlouva pokračuje',
	feedBackFinishContract: 'Vyřízeno - ukončení smlouvy',
	feedBackNoPermission: 'Vystaveno neoprávněně',
	feedBackConfirmMessage: 'Zadaná Zpětná vazba už nejde změnit.',
	feedBackSelectedFeedback: 'vybranou zpětnou vazbu?',
	feedbackInfo:
		'Zadaná zpětná vazba neodchází na správu smluv, ale slouží pro potřeby statistiky a řízení obchodní sítě.',
};

const informtions = {
	informationsSubheader: 'Oprávněná osoba',
	informationsRole: 'Role',
	informationsName: 'Jméno a příjmení',
	informationsInsuranceNumber: 'Rodné číslo',
	informationsAddress: 'Adresa',
	informationsFirst: '1. pojištěný',
	informationsSecond: '2. pojištěný',
	informationsChild: 'Pojištěné dítě',
};

const notes = {
	notesPlaceHolder: 'Klikněte pro psaní',
	notesSubheader: 'Text úkolu a poznámky od uživatele',
	notesInfo: 'Zadané poznámky neodchází na správu smluv, ale slouží pro potřeby obchodníka.',
	buttonErase: 'Zrušit',
	noteFieldLabel: 'Poznámky k úkolu',
};

const table = {
	tableHeadOrderNr: 'Poř. číslo',
	tableHeadReachedNumber: 'Získatelské/Agenturní číslo',
	tableHeadName: 'Jméno',
	tableHeadPhone: 'Telefon',
	tableHeadEmail: 'E-mail',
	tableSubheader: 'Kontakt na správce PS',
	tableHeadRole: 'Role',
	tableHeadLogin: 'Login',
};

const taskGrid = {
	taskGridSubheader: 'Detail úkolu',
	taskGridTypeOfActivity: 'Typ činnosti',
	taskGridId: 'ID úkolu',
	taskGridSubtype: 'Podtyp / Důvod kontaktování',
	taskGridInvestigator: 'Řešitel úkolu',
	taskGridCreateDate: 'Datum vytvoření úkolu',
	taskGridCautionDate: 'Termín upozornění',
	taskGridBonita: 'Bonita',
	taskGridDeadlineDate: 'Termín splnění úkolu',
	taskGridNewPS: 'Číslo nově sjednané PS',
	taskGridNewProposalNo: 'Číslo nového návrhu PS',
	taskGridAssignOn: 'Přiděleno na',
	taskGridSolvedData: 'Datum splnění',
	taskGridBirthDate: 'Datum narození',
};

const policyAdminsTable = {
	inactivePolicyAdmin: 'Neaktivní obchodník',
	policyAdmin: 'Správce',
	subseller: 'Podobchodník',
};

const errors = {
	errorAttachmentNotFound:
		'Dokument (příloha) nebyl v digitálním archivu nalezen, pravděpodobně ještě nebyl doručen ze zdrojového systému. Zkuste to prosím později.',
};

export default {
	...additionalInformation,
	...asideBar,
	...asideBarButtons,
	...attachments,
	...errors,
	...taskGrid,
	...feedBack,
	...informtions,
	...notes,
	...table,
	...policyAdminsTable,
};
